import styled from 'styled-components';
import { colors } from "../../../components/common/ui/globalColors";

export const StyledDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;

  label {
    width: fit-content;
  }

  .borderless-input-border {
    border: none;
    border-radius: 19px;
    box-shadow: 0 3px 10px ${colors.semiTransparentColors.shadowGray};
    margin-bottom: 8px;

    &::placeholder {
      color: ${colors.semiTransparentColors.grayBlue};
    }
  }
`
